import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import Contract from '../contract/Model.Contract';
import contractStatusAuditLogListApi from './list/Api.ContractStatusAuditLog.List';

export default class ContractStatusAuditLog
  extends Model<Model.IContractStatusAuditLog>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractStatusAuditLog>
{
  id: number;
  oldStatus?: Model.Enum.ContractStatusCode;
  newStatus?: Model.Enum.ContractStatusCode;
  createdAtUtc: string;
  modifiedAtUtc: string;
  contractId: number;
  contract: Contract;
  createdBy?: User;
  createdById?: number;
  modifiedBy?: User;
  modifiedById?: number;

  constructor(
    data: Partial<Model.IContractStatusAuditLog> | Utils.FormData<Model.IContractStatusAuditLog>,
    language?: Locale.Languages
  ) {
    super(
      {
        contract: Contract,
        createdBy: User,
        modifiedBy: User,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this?.oldStatus,
      info: this?.newStatus,
      subtitle: this.contract?.displayInfo.title,
    };
  }

  static async list(body?: Api.Core.ContractStatusAuditLog.List.IRequest) {
    const { payload, ...rest } = await contractStatusAuditLogListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractStatusAuditLog(it)),
        count: payload.count,
      },
    };
  }
}
